import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { CheckLineIcon as p } from "@ifrc-go/icons";
import { _ as i } from "../../../cs-Dfox81s-.js";
import "../../../type-Dku6Xzl6.js";
import '../../../index73.css';const _ = "_option_11p37_1", d = "_icon_11p37_6", m = "_label_11p37_14", f = "_overflow-container_11p37_20", v = "_description_11p37_25", o = {
  option: _,
  icon: d,
  label: m,
  overflowContainer: f,
  description: v
};
function w(s) {
  const {
    className: c,
    label: l,
    description: t,
    iconClassName: a,
    labelClassName: r
  } = s;
  return /* @__PURE__ */ e("div", { className: i(o.option, c), children: [
    /* @__PURE__ */ n("div", { className: i(o.icon, a), children: /* @__PURE__ */ n(p, {}) }),
    /* @__PURE__ */ e("div", { className: i(o.label, r), children: [
      /* @__PURE__ */ n("div", { className: o.overflowContainer, children: l }),
      /* @__PURE__ */ n("div", { className: i(o.overflowContainer, o.description), children: t })
    ] })
  ] });
}
export {
  w as default
};
